export default {
  app: {
    privacy: {
      policy: 'Zásady ochrany osobních údajů',
      expansive: 'Používáním Expansive souhlasíte s Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Platnost relace vypršela',
    sessionExpiredDescription:
      'Vaše relace vypršela. Přihlaste se prosím znovu, abyste mohli pokračovat v používání aplikace.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Vyberte jazyk',
      chooseLanguageDescription:
        'Vyberte si preferovaný jazyk pro aplikaci. To změní jazyk rozhraní a obsahu.',
    },
    userSelection: {
      cancel: 'Zrušit',
      createNewUser: 'Jejich jméno není v seznamu',
      newUser: 'Nový uživatel',
      selectAnExistingUser: 'Vyberte stávajícího uživatele',
      selectUserHint:
        'Vyberte stávajícího uživatele nebo vytvořte nového, abyste mohli pokračovat.',
      startTypingToSearch: 'Začněte psát...',
    },
    verification: {
      codeVerification: {
        continue: 'Pokračovat',
        header: 'Zadejte přístupový kód na místo',
        invalidCode: 'Neplatný kód, zkuste to prosím znovu.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Pokračovat bez ověření polohy',
        enterSiteAccessCode: 'Zadejte přístupový kód na místo',
        locationNotEnabledOrAvailable: 'Proč to vidím?',
        notAvailable: {
          description: 'GPS poloha není na tomto zařízení podporována.',
          header: 'Poloha není podporována',
        },
        notEnabled: {
          description: 'Služby polohy nejsou povoleny nebo nebylo uděleno oprávnění.',
          header: 'Poloha není povolena',
        },
        notVerified: {
          description: 'GPS naznačuje, že nejste na místě.',
          header: 'Poloha nebyla ověřena',
        },
        tryAgain: 'Zkusit znovu',
        unavailable: {
          description: 'Nemohli jsme ověřit vaši GPS polohu.',
          header: 'Poloha není k dispozici',
        },
        unknown: {
          description: 'Nemůžeme určit vaši polohu.',
          header: 'Poloha neznámá',
        },
        verified: {
          description: 'GPS naznačuje, že jste na místě.',
          header: 'Poloha ověřena',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nenalezeny žádné prostředky',
        emptyDescription: 'K tomuto pracovnímu příkazu nejsou přiřazeny žádné prostředky.',
        warrantyParts: 'Záruka na díly vyprší',
        serialNumber: 'Sériové číslo',
        none: '<žádný>',
      },
      updates: {
        emptyTitle: 'Nenalezeny žádné aktualizace',
        emptyDescription: 'K tomuto pracovnímu příkazu nejsou žádné aktualizace.',
        unknownUser: 'Neznámý uživatel',
        none: 'Žádné',
        addComment: {
          buttonLabel: 'Přidat komentář',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Nebezpečí',
          no: 'Ne',
          yes: 'Ano',
        },
      },
    },
    attachmentsList: {
      attachments: 'Přílohy',
      documents: 'Dokumenty',
      siteDocuments: 'Dokumenty na místě',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Nebezpečí',
        induction: 'Úvod',
        safeToProceed: 'Bezpečné pokračování',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Termín splatnosti',
        activeSessions: 'Aktivní relace',
        activeSessionsDescription:
          'Již jste přihlášeni do následujících pracovních příkazů. Musíte se odhlásit z těchto pracovních příkazů, než se přihlásíte do nového pracovního příkazu.',
        resumeSession: 'Pokračovat',
        startTime: 'Začalo v',
        unexpectedErrorTitle: 'Neočekávaná chyba',
        unexpectedErrorMessage:
          'Při pokusu o vytvoření vašich relací došlo k neočekávané chybě. Zkuste to prosím znovu později.',
        engineerNotFound: 'Technik nenalezen',
        engineerNotFoundDescription:
          'Technik, kterého se snažíte přihlásit, nebyl v systému nalezen. Kontaktujte prosím svého administrátora.',
      },
      verification: {
        code: {
          description:
            'Pro přihlášení prosím získejte 4-ciferný kód od vedoucího místa nebo určeného kontaktu.',
        },
        geo: {
          continue: 'Pokračovat',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Pro dokončení návštěvy prosím získejte přístupový kód od vedoucího pracoviště nebo určeného kontaktu.',
            checkOut: 'Odhlásit',
            completeBeforeLeaving: 'Před odchodem prosím vyplňte následující formulář.',
            continue: 'Pokračovat',
            noResolutionSelected: 'Před pokračováním prosím vyberte řešení.',
            quoteRequired: {
              hint: 'Návštěva dokončena, nabídka bude následovat',
              label: 'Požadována nabídka',
            },
            returnVisitRequired: {
              hint: 'Budeme se vracet znovu k dokončení',
              label: 'Požadována opakovaná návštěva',
            },
            serviceCompleted: {
              hint: 'Není vyžadována žádná další akce',
              label: 'Služba dokončena',
            },
            uploadCheckout: 'Nahrajte soubor, fotografii nebo video',
            visitNotes: 'Poznámky k návštěvě',
            workOrderResolution: 'Řešení pracovního příkazu',
            enterNotes: 'Zadejte jakékoli poznámky zde...',
            errors: {
              timedOut: 'Čas vypršel, překročeno 30 sekund. Zkuste to prosím znovu.',
              closingSession: 'Chyba při uzavírání relace',
            },
          },
          success: {
            description:
              'Děkujeme za návštěvu {site}. | {site} má stále 1 otevřený pracovní příkaz. | {site} má stále {count} otevřených pracovních příkazů.',
            endVisit: 'Ukončit návštěvu',
            header: 'Úspěšně jste se odhlásili',
            viewWorkOrders: 'Přihlásit se k dalšímu pracovnímu příkazu',
          },
          verification: {
            code: {
              description:
                'Pro odhlášení prosím získejte 4-ciferný kód od vedoucího místa nebo určeného kontaktu.',
              continue: 'Pokračovat',
            },
            geo: {
              checkOut: 'Odhlásit',
              continue: 'Pokračovat',
            },
          },
        },
        detail: {
          assets: 'Prostředky',
          call: 'Zavolat',
          checkOut: 'Odhlásit',
          closed: 'Uzavřeno',
          details: 'Detaily',
          dueBy: 'Termín splatnosti',
          manageEngineers: 'Spravovat techniky',
          notAvailable: 'Není k dispozici',
          pointOfContact: 'Kontaktní osoba',
          siteAccessTimes: 'Časy přístupu na místo',
          siteAccessInstructions: 'Pokyny pro přístup',
          siteAddress: 'Adresa místa',
          siteNotes: 'Poznámky k místu',
          siteTelephone: 'Telefon na místo',
          siteLocation: 'Poloha místa',
          updates: 'Aktualizace',
          more: 'Více',
          mismatchErrorTitle: 'Chyba pracovního příkazu',
          mismatchErrorMessage:
            'Pracovní příkaz, který se snažíte otevřít, se neshoduje s tím, do kterého jste aktuálně přihlášeni. Zkontrolujte prosím svůj pracovní příkaz a zkuste to znovu.',
          siteDocuments: 'Dokumenty na místě',
          validFrom: 'Platné od',
          validUntil: 'Platné do',
          documentName: 'Název dokumentu',
          documentType: 'Typ dokumentu',
          attachments: 'Soubory pracovního příkazu',
          download: 'Stáhnout',
          workDetails: 'Podrobnosti o práci',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Přidat asistenta technika',
            assistantEngineers: 'Asistenti technika',
            description: 'Z bezpečnostních důvodů prosím uveďte jména všech techniků na místě.',
            editMainEngineer: 'Upravit hlavního technika',
            errors: {
              creatingEngineer: 'Chyba při vytváření technika',
              creatingSession: 'Chyba při vytváření relace',
            },
            header: 'Technici na místě',
            mainEngineer: 'Hlavní technik',
            newAssistantEngineer: 'Zadejte celé jméno',
            next: 'Další',
            removeEngineer: 'Odstranit technika',
            selectExistingAssistantEngineer: 'Začněte psát jejich jméno',
          },
          index: {
            description: 'Z bezpečnostních důvodů prosím uveďte jména všech techniků na místě.',
            errorCreatingEngineer: 'Chyba při vytváření technika, zkuste to prosím znovu.',
            header: 'Technici na místě',
            hintMainEngineer: 'Zadejte celé jméno hlavního technika',
            newMainEngineer: 'Nový hlavní technik',
            next: 'Další',
            selectExistingMainEngineer: 'Vyberte stávajícího hlavního technika',
            yes: 'Ano',
            no: 'Ne',
            mainEngineerLabel: 'Jste hlavní technik?',
          },
        },
        index: {
          callUsOn: 'Zavolejte nám na číslo {phoneNumber}',
          description: 'Nemůžete najít, co hledáte?',
          dueBy: 'Termín splatnosti',
          header: 'Vyberte pracovní příkaz',
          notAvailable: 'Není k dispozici',
          searchWorkOrders: 'Hledat pracovní příkazy...',
        },
        manageEngineers: {
          manageEngineers: 'Spravovat techniky',
          notWorking: 'Neaktivní pracovníci',
          pause: 'Pozastavit',
          resume: 'Pokračovat',
          workingNow: 'Aktivní pracovníci',
          startTime: 'Čas začátku',
          endTime: 'Čas konce',
          duration: 'Doba trvání',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Zpětná vazba',
            feedbackDescription:
              'Prosím, poskytněte zpětnou vazbu k pracovnímu příkazu, abychom mohli zlepšit naše služby.',
            feedbackLabel: 'Zpětná vazba',
            filesLabel: 'Přílohy',
            submissionLabel: 'Odeslat zpětnou vazbu',
          },
          hazards: {
            back: 'Zpět',
            hazards: 'Nebezpečí',
            next: 'Další',
            no: 'Ne',
            noTasksForHazard: 'Pro toto nebezpečí nejsou žádné úkoly k dokončení.',
            yes: 'Ano',
          },
          induction: {
            continue: 'Pokračovat',
            induction: 'Úvod',
          },
          index: {
            checkIn: 'Přihlásit se',
            description: 'Prosím, vyplňte následující hodnocení rizik pro vybranou práci.',
            fail: 'Chyba při zpracování kontrol zahájení pracovního příkazu.',
            haltMessage:
              'Byla zjištěna potenciální rizika. Prosím, přestaňte pracovat, zkontrolujte bezpečnostní pokyny a kontaktujte svého nadřízeného pro další instrukce.',
            header: 'Kontroly před zahájením práce',
            endVisit: 'Ukončit návštěvu',
            leaveFeedback: 'Zanechat zpětnou vazbu',
          },
          safeToProceed: {
            continue: 'Pokračovat',
            safeToProceed: 'Bezpečné pokračování',
          },
        },
      },
    },
    index: {
      title: 'Vítejte',
      description: 'Naskenujte QR kód na vaší lokaci pro zahájení.',
    },
    login: {
      errorTitle: 'Neočekávaná chyba',
      errorMessage:
        'Při pokusu o přihlášení pomocí QR kódu došlo k neočekávané chybě. Zkuste to prosím znovu.',
    },
    unauthenticated: {
      welcome: {
        title: 'Vítejte na {site}',
        description:
          'Než vám budeme moci ukázat jakékoli pracovní příkazy, musíme ověřit vaše údaje. Klikněte prosím na tlačítko níže pro pokračování.',
        next: 'Pokračovat',
      },
      index: {
        errorTitle: 'Neočekávaná chyba',
        errorMessage:
          'Při pokusu o přihlášení pomocí QR kódu došlo k neočekávané chybě. Zkuste to prosím znovu.',
      },
      contractor: {
        title: 'Pro koho pracujete?',
        contractor: 'Dodavatel',
        contractorLabel: 'Začněte psát název vaší společnosti',
        contractorHint: 'Musíte zadat 3 znaky nebo více, abyste viděli výsledky',
        defaultSelectPlaceholder: '--Vyberte prosím--',
        next: 'Další',
      },
      user: {
        title: 'Kdo jste?',
        cancel: 'Zrušit',
        createNewUserLabel: 'Moje jméno není v seznamu',
        existingUserLabel: 'Začněte psát své jméno',
        existingUserHint: 'Musíte zadat 3 znaky nebo více, abyste viděli výsledky',
        newUserLabel: 'Zadejte své celé jméno',
        next: 'Další',
        user: 'Uživatel',
      },
      verification: {
        methods: {
          add: {
            add: 'Přidat metodu ověření',
            defaultSelectPlaceholder: '--Vyberte prosím--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Ji již máte čekající žádost o tuto metodu ověření, která čeká na schválení administrátorem. Přidání nové metody ji přepíše.',
            method: 'Metoda',
            methodLabel: 'Metoda',
            mobileCountryHint: 'Vyberte prosím kód vaší země',
            mobileCountryLabel: 'Kód země mobilního telefonu',
            mobileHint: 'Zadejte prosím své mobilní číslo',
            mobileLabel: 'Mobilní',
            title: 'Přidat metodu ověření',
          },
          confirm: {
            confirm: 'Potvrdit',
            description: 'Prosím potvrďte svou metodu ověření pro pokračování.',
            label: 'Zadejte svůj kód',
            resend: 'Znovu odeslat',
            resendPrompt: 'Nedostali jste kód?',
            title: 'Potvrďte metodu ověření',
          },
          confirmed: {
            description:
              'Budete informováni, jakmile bude tato metoda ověření schválena vaším administrátorem, a poté ji budete moci použít k ověření své identity.',
            forceApproval:
              'Dokud nebude schválena, nebudete moci přistupovat k pracovním příkazům.',
            nonForceApproval:
              'Mezitím můžete pokračovat v přístupu k pracovním příkazům se sníženým přístupem.',
            nonForceApprovalButtonLabel: 'Pokračovat se sníženým přístupem',
            title: 'Čekání na schválení',
          },
          addNew: 'Přidat novou metodu ověření',
          description:
            'Musíme ověřit vaši identitu, abychom vám mohli poskytnout plný přístup k pracovnímu příkazu.',
          email: 'Email',
          hint: 'Odkaz na vaši vybranou metodu ověření vám bude zaslán e-mailem, který vám poskytne plný přístup k pracovnímu příkazu. Pokud potřebujete změnit nějaké existující metody ověření, kontaktujte prosím svého administrátora.',
          label: 'Vyberte metodu ověření',
          next: 'Další',
          pendingHint: 'Čekání na schválení od vašeho administrátora',
          sms: 'SMS',
          title: 'Ověření',
        },
        optional: {
          hint: 'Ověření vašich uživatelských údajů vám poskytne plný přístup k pracovnímu příkazu',
          label: 'Chcete ověřit své uživatelské údaje?',
          next: 'Další',
          no: 'Ne',
          noHint:
            'Nechci ověřovat své uživatelské údaje a pokračovat se sníženým přístupem k pracovnímu příkazu',
          title: 'Ověření',
          yes: 'Ano',
          yesHint: 'Chci ověřit své uživatelské údaje a získat plný přístup k pracovnímu příkazu',
        },
        sent: {
          description:
            'Odkaz na přihlášení byl zaslán na {identifier}. Klikněte prosím na odkaz, abyste dokončili přihlášení.',
          title: 'Odkaz na přihlášení zaslán',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Včera',
      today: 'Dnes',
      days: {
        monday: 'Pondělí',
        tuesday: 'Úterý',
        wednesday: 'Středa',
        thursday: 'Čtvrtek',
        friday: 'Pátek',
        saturday: 'Sobota',
        sunday: 'Neděle',
      },
      months: {
        january: 'Leden',
        february: 'Únor',
        march: 'Březen',
        april: 'Duben',
        may: 'Květen',
        june: 'Červen',
        july: 'Červenec',
        august: 'Srpen',
        september: 'Září',
        october: 'Říjen',
        november: 'Listopad',
        december: 'Prosinec',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Něco se pokazilo',
      message: 'Zkuste prosím znovu naskenovat QR kód.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Neznámý uživatel',
      },
      none: 'Žádné',
      types: {
        stateTransition: 'Stav změněn',
        contractorAssigned: 'Dodavatel přiřazen',
        engineerAssigned: 'Technik přiřazen',
        serviceAssigned: 'Služba přiřazena',
        priorityChanged: 'Priorita změněna',
        actionableDateChanged: 'Datum k vyřízení změněno',
        dueDateChanged: 'Datum splatnosti změněno',
        etaDateChanged: 'Odhadované datum příjezdu změněno',
        spendLimitApproved: 'Limit výdajů schválen',
        spendLimitCancelled: 'Žádost o limit výdajů zrušena',
        spendLimitRejected: 'Limit výdajů zamítnut',
        spendLimitRequested: 'Žádost o limit výdajů',
        jobSheetUploaded: 'Pracovní list nahrán',
        slaAlertSent: 'Upozornění na překročení SLA času příjezdu',
        issuedWorkPermit: 'Pracovní povolení vydáno',
        requestForServiceSent: 'Žádost o službu odeslána',
        comment: 'Přidán komentář',
        unknown: 'Neznámá událost',
      },
      labels: {
        actionableDate: 'Datum k vyřízení',
        comment: 'Komentář',
        file: 'Soubor',
        contractor: 'Dodavatel',
        dueDate: 'Datum splatnosti',
        etaDate: 'Odhadované datum příjezdu',
        engineer: 'Technik',
        priority: 'Priorita',
        requestForService: 'Žádost o službu',
        service: 'Služba',
        spendLimit: 'Limit výdajů',
        status: 'Stav',
        workPermit: 'Pracovní povolení',
      },
    },
  },
}
